export default {
  'form-step-form.basic.title': '基礎表單',
  'form-step-form.basic.description':
    '表單頁用於向用戶收集或驗證信息，基礎表單常見於數據項較少的表單場景。',

  'form-step-form.email.required': '請輸入郵箱地址！',
  'form-step-form.email.wrong-format': '郵箱地址格式錯誤！',
  'form-step-form.userName.required': '請輸入賬戶!',
  'form-step-form.password.required': '請輸入密碼！',
  'form-step-form.password.twice': '兩次輸入的密碼不匹配!',
  'form-step-form.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'form-step-form.strength.strong': '強度：強',
  'form-step-form.strength.medium': '強度：中',
  'form-step-form.strength.short': '強度：太短',
  'form-step-form.confirm-password.required': '請確認密碼！',
  'form-step-form.phone-number.required': '請輸入手機號！',
  'form-step-form.phone-number.wrong-format': '手機號格式錯誤！',
  'form-step-form.verification-code.required': '請輸入驗證碼！',
  'form-step-form.title.required': '請輸入標題',
  'form-step-form.date.required': '請選擇起止日期',
  'form-step-form.goal.required': '請輸入目標描述',
  'form-step-form.standard.required': '請輸入衡量標淮',

  'form-step-form.form.get-captcha': '獲取驗證碼',
  'form-step-form.captcha.second': '秒',
  'form-step-form.form.optional': '（選填）',
  'form-step-form.form.submit': '提交',
  'form-step-form.form.save': '保存',
  'form-step-form.email.placeholder': '郵箱',
  'form-step-form.password.placeholder': '至少6位密碼，區分大小寫',
  'form-step-form.confirm-password.placeholder': '確認密碼',
  'form-step-form.phone-number.placeholder': '手機號',
  'form-step-form.verification-code.placeholder': '驗證碼',
  'form-step-form.title.label': '標題',
  'form-step-form.title.placeholder': '給目標起個名字',
  'form-step-form.date.label': '起止日期',
  'form-step-form.placeholder.start': '開始日期',
  'form-step-form.placeholder.end': '結束日期',
  'form-step-form.goal.label': '目標描述',
  'form-step-form.goal.placeholder': '請輸入妳的階段性工作目標',
  'form-step-form.standard.label': '衡量標淮',
  'form-step-form.standard.placeholder': '請輸入衡量標淮',
  'form-step-form.client.label': '客戶',
  'form-step-form.label.tooltip': '目標的服務對象',
  'form-step-form.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'form-step-form.invites.label': '邀評人',
  'form-step-form.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'form-step-form.weight.label': '權重',
  'form-step-form.weight.placeholder': '請輸入',
  'form-step-form.public.label': '目標公開',
  'form-step-form.label.help': '客戶、邀評人默認被分享',
  'form-step-form.radio.public': '公開',
  'form-step-form.radio.partially-public': '部分公開',
  'form-step-form.radio.private': '不公開',
  'form-step-form.publicUsers.placeholder': '公開給',
  'form-step-form.option.A': '同事甲',
  'form-step-form.option.B': '同事乙',
  'form-step-form.option.C': '同事丙',
};
